import { Tooltip, type TooltipProps } from '@mantine/core';
import { CSSProperties, FC } from 'react';

const DEFAULT_EVENTS: NonNullable<TooltipProps['events']> = {
  hover: true,
  focus: true,
  touch: true,
};

const DEFAULT_OFFSET: NonNullable<TooltipProps['offset']> = {
  mainAxis: 8,
  crossAxis: -22,
};

const DEFAULT_TOOLTIP_STYLE: CSSProperties = {
  boxShadow: '0px 0px 10px 0px rgba(0, 32, 51, 0.10)',
  width: 'fit-content',
  maxWidth: 300,
};

export type AppTooltipProps = TooltipProps;

export const AppTooltip: FC<AppTooltipProps> = ({
  events = DEFAULT_EVENTS,
  color = '#fff',
  c = '#000',
  multiline = true,
  p = 12,
  withArrow = true,
  position = 'top-start',
  offset = DEFAULT_OFFSET,
  arrowPosition = 'side',
  arrowOffset = 28,
  arrowSize = 6,
  w = 'fit-content',
  maw = 300,
  zIndex = 100001,
  style,
  children,
  ...rest
}) => (
  <Tooltip
    events={events}
    color={color}
    c={c}
    multiline={multiline}
    p={p}
    withArrow={withArrow}
    position={position}
    offset={offset}
    arrowPosition={arrowPosition}
    arrowOffset={arrowOffset}
    arrowSize={arrowSize}
    w={w}
    maw={maw}
    zIndex={zIndex}
    style={{ ...DEFAULT_TOOLTIP_STYLE, ...style }}
    {...rest}>
    {children}
  </Tooltip>
);
